
import axiosInstance from './api/axios';

class WhatsAppService {
  async submitEmbeddedSignup(payload) {
    try {
      const response = await axiosInstance.post(`whatsapp/embedded-signup`, payload);
      return response;
    } catch (error) {
      throw error.response?.data || error;
    }
  }
}

export default new WhatsAppService(); 